import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojyotilingadarshan() {


const cardData = {
keyword: "Pune to Jyotirlinga Darshan Package",
headingDescription: "Pune to Jyotirlinga Darshan Package is a convenient private travel option for devotees planning a pilgrimage to the revered Jyotirlinga temples of Maharashtra. Depending on the available time, travelers can plan a three-Jyotirlinga, five-Jyotirlinga, or customized religious tour covering destinations such as Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Citysky Cabs can arrange suitable vehicles for families, couples, senior citizens, and larger groups, including comfortable Innova Crysta options. The journey can be planned from Pune with flexible pickup locations, temple-wise routing, overnight stays, and one or multiple days of pilgrimage travel.",
topPlaces: [
{
title: "Bhimashankar Jyotirlinga",
description: "Bhimashankar Jyotirlinga is one of the most important Shiva pilgrimage destinations in Maharashtra and is surrounded by the scenic Sahyadri landscape. A private cab from Pune provides convenient transportation for devotees traveling with family or senior members and can be included as part of a larger Jyotirlinga darshan itinerary."
},
{
title: "Trimbakeshwar Jyotirlinga",
description: "Trimbakeshwar Jyotirlinga near Nashik is a prominent pilgrimage destination dedicated to Lord Shiva and is an important stop for devotees planning a Maharashtra Jyotirlinga tour. Private cab transportation allows travelers to reach Trimbakeshwar comfortably while coordinating the temple visit with other destinations."
},
{
title: "Grishneshwar Jyotirlinga",
description: "Grishneshwar Jyotirlinga near the Ellora Caves is a significant religious destination for devotees undertaking a Jyotirlinga pilgrimage. A dedicated cab from Pune can make the journey convenient for families and groups while allowing the temple visit to be combined with nearby heritage attractions."
},
{
title: "Aundha Nagnath Jyotirlinga",
description: "Aundha Nagnath is an important Shiva pilgrimage destination in Maharashtra and is included in many extended Jyotirlinga travel plans. Devotees traveling from Pune can arrange a private cab to Aundha Nagnath with an itinerary designed around temple darshan, travel time, rest breaks, and other pilgrimage stops."
},
{
title: "Parli Vaijnath Jyotirlinga",
description: "Parli Vaijnath is a revered Shiva temple and an important destination for devotees planning a five-Jyotirlinga pilgrimage across Maharashtra. Private transportation from Pune makes it possible to include Parli in a multi-day itinerary while keeping the journey organized for families and groups."
},
{
title: "Ellora Caves",
description: "Ellora Caves are a major heritage attraction located close to Grishneshwar Jyotirlinga and can be included in a religious and cultural travel itinerary. Devotees visiting Grishneshwar can plan additional time for Ellora when arranging a private Jyotirlinga tour from Pune."
},
{
title: "Trimbakeshwar Temple Area",
description: "The Trimbakeshwar temple area is an important spiritual destination around which devotees often plan their Nashik pilgrimage. A private cab provides flexibility for visiting the temple along with nearby religious and cultural locations while maintaining a convenient travel schedule."
},
{
title: "Shirdi",
description: "Shirdi is one of Maharashtra's prominent pilgrimage destinations and can be combined with a Jyotirlinga tour depending on the traveler's preferred itinerary. Families undertaking an extended religious journey can use private transportation to include Shirdi along with selected Shiva temples."
},
{
title: "Nashik",
description: "Nashik is an important pilgrimage city and provides access to Trimbakeshwar along with several other religious destinations. Travelers planning a Jyotirlinga darshan package from Pune can include Nashik in their itinerary for temple visits, accommodation, meals, and planned overnight stays."
},
{
title: "Aundha Nagnath Pilgrimage Route",
description: "The Aundha Nagnath pilgrimage route can be included in an extended Maharashtra Jyotirlinga circuit for devotees covering multiple Shiva temples. A dedicated cab provides flexibility for route planning, family travel, luggage, rest stops, and connections with Parli Vaijnath or other religious destinations."
}
],
services: [
{
name: "Panch jyotirlinga tour from pune",
description: "Panch Jyotirlinga tour from Pune provides a private travel arrangement for devotees wishing to visit five prominent Jyotirlinga temples across Maharashtra. The itinerary can be planned over multiple days with suitable vehicle selection, temple-wise routing, rest breaks, and accommodation planning."
},
{
name: "Panch jyotirlinga darshan from pune",
description: "Panch Jyotirlinga darshan from Pune is suitable for families, couples, senior citizens, and religious groups planning an extended pilgrimage. Private cab transportation allows the journey to be organized around the selected temples, available travel time, and preferred daily schedule."
},
{
name: "Pune jyotirlinga darshan",
description: "Pune Jyotirlinga darshan provides a convenient starting point for devotees planning a Maharashtra Shiva pilgrimage. Travelers can arrange private transportation from Pune and customize the journey according to whether they want to visit three, five, or selected Jyotirlinga temples."
},
{
name: "3 jyotirlinga in maharashtra tour package",
description: "3 Jyotirlinga in Maharashtra tour package is suitable for devotees with limited travel time who want to cover three important Shiva pilgrimage destinations. The itinerary can be organized around temple locations, travel distance, overnight requirements, passenger count, and the preferred vehicle."
},
{
name: "3 jyotirlinga in maharashtra tour package from pune",
description: "3 Jyotirlinga in Maharashtra tour package from Pune provides private transportation for devotees beginning their pilgrimage in Pune. A customized itinerary can be prepared according to the selected temples, number of days, group size, and preferred travel schedule."
},
{
name: "maharashtra 5 jyotirlinga darshan",
description: "Maharashtra 5 Jyotirlinga darshan is an extended pilgrimage option for devotees who want to visit Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. A private vehicle can make the multi-destination journey more organized and convenient for families and groups."
},
{
name: "pune to bhimashankar cab",
description: "Pune to Bhimashankar cab provides direct private transportation for devotees visiting Bhimashankar Jyotirlinga. The cab can be arranged for individuals, families, and groups and can also be incorporated into a broader Jyotirlinga pilgrimage itinerary."
},
{
name: "pune to trimbakeshwar cab",
description: "Pune to Trimbakeshwar cab offers private transportation from Pune to the Trimbakeshwar Jyotirlinga temple near Nashik. Travelers can arrange the journey as an individual temple visit or combine it with other religious destinations as part of a multi-day pilgrimage."
},
{
name: "pune to grishneshwar jyotirlinga cab",
description: "Pune to Grishneshwar Jyotirlinga cab provides direct transportation to the revered Shiva temple near Ellora. It is suitable for families and pilgrimage groups and can be planned alongside Ellora Caves and other nearby destinations according to the travel itinerary."
},
{
name: "pune to aundha nagnath cab service",
description: "Pune to Aundha Nagnath cab service provides private long-distance transportation for devotees traveling toward Aundha Nagnath Jyotirlinga. The journey can be arranged as a dedicated temple trip or included within a larger Maharashtra Jyotirlinga circuit."
},
{
name: "pune to parli vaijnath cab service",
description: "Pune to Parli Vaijnath cab service offers private transportation for devotees visiting Parli Vaijnath Jyotirlinga. A suitable vehicle can be selected according to group size and luggage, while the journey can be incorporated into a broader five-Jyotirlinga pilgrimage."
},
{
name: "cheapest jyotirlinga darshan cab booking",
description: "Cheapest Jyotirlinga darshan cab booking is a commonly searched option by travelers looking to manage the transportation budget for their pilgrimage. The final cost depends on the selected vehicle, number of days, temples covered, passenger count, and overall itinerary."
},
{
name: "jyotirlinga darshan package from pune",
description: "Jyotirlinga darshan package from Pune provides a private transportation solution for devotees planning a religious tour from Pune across Maharashtra. The package can be customized according to the number of Jyotirlingas, travel duration, vehicle category, and preferred pilgrimage route."
},
{
name: "jyotirlinga darshan tour package",
description: "Jyotirlinga darshan tour package can be planned for individuals, families, senior citizens, and devotional groups visiting multiple Shiva temples. Private cab transportation provides flexibility for route planning, temple stops, overnight stays, meals, and rest breaks throughout the journey."
},
{
name: "innova crysta for jyotirlinga darshan",
description: "Innova Crysta for Jyotirlinga darshan is a spacious private vehicle option for families and groups undertaking a multi-temple pilgrimage. Its additional passenger and luggage space makes it suitable for longer journeys where travelers want to remain together throughout the religious tour."
}
],
tableData: [
["Panch jyotirlinga tour from pune"],
["Panch jyotirlinga darshan from pune"],
["Pune jyotirlinga darshan"],
["3 jyotirlinga in maharashtra tour package"],
["3 jyotirlinga in maharashtra tour package from pune"],
["maharashtra 5 jyotirlinga darshan"],
["pune to bhimashankar cab"],
["pune to trimbakeshwar cab"],
["pune to grishneshwar jyotirlinga cab"],
["pune to aundha nagnath cab service"],
["pune to parli vaijnath cab service"],
["cheapest jyotirlinga darshan cab booking"],
["jyotirlinga darshan package from pune"],
["jyotirlinga darshan tour package"],
["innova crysta for jyotirlinga darshan"]
],
whychoose: [
{
WhyChooseheading: "Multi-Jyotirlinga Travel Planning",
WhyChoosedescription: "A private cab makes it easier to coordinate a pilgrimage covering several Jyotirlinga temples across Maharashtra. The itinerary can be discussed around the selected temples, available days, preferred route, overnight stops, and the number of devotees traveling together."
},
{
WhyChooseheading: "Three and Five Temple Options",
WhyChoosedescription: "Devotees can plan a shorter three-Jyotirlinga itinerary or an extended five-Jyotirlinga journey depending on their available time. Flexible travel arrangements allow the pilgrimage to be structured around the temples the group wants to visit."
},
{
WhyChooseheading: "Comfortable Family Transportation",
WhyChoosedescription: "Families can travel together in a dedicated vehicle throughout the pilgrimage instead of arranging separate transportation between temple destinations. This is particularly useful when traveling with children, senior citizens, luggage, or a larger family group."
},
{
WhyChooseheading: "Innova Crysta for Groups",
WhyChoosedescription: "Innova Crysta provides a spacious option for devotees traveling as a family or small group. The additional seating and luggage capacity can be useful during a multi-day religious journey involving several temple visits and longer road travel."
},
{
WhyChooseheading: "Flexible Pickup From Pune",
WhyChoosedescription: "The pilgrimage can begin from a convenient Pune location based on the traveler's requirement. Pickup arrangements can be planned for residential areas, hotels, offices, Pune Airport, or other suitable starting points before beginning the Jyotirlinga route."
},
{
WhyChooseheading: "Customized Pilgrimage Itinerary",
WhyChoosedescription: "Every group may have different temple priorities and time availability. A private cab allows the journey to be discussed around temple sequence, number of days, rest periods, overnight stays, additional pilgrimage destinations, and preferred travel timings."
},
{
WhyChooseheading: "Suitable for Senior Citizens",
WhyChoosedescription: "Private transportation can provide a more convenient travel arrangement for families accompanying senior citizens on a religious journey. The group can remain together in one vehicle and plan breaks according to the comfort requirements of the travelers."
},
{
WhyChooseheading: "Advance Booking for Yatra Dates",
WhyChoosedescription: "Advance cab booking helps devotees organize their vehicle before the pilgrimage begins. This can be useful for families and groups with fixed temple schedules, planned overnight stays, specific vehicle requirements, or travel dates during busy pilgrimage periods."
}
]
};








const faqData = [
{
question: "Can I arrange a Pune to Jyotirlinga Darshan Package with Citysky Cabs?",
answer: "Devotees planning a Jyotirlinga pilgrimage from Pune can enquire about a private cab package with Citysky Cabs. The travel plan can be discussed according to the selected temples, number of passengers, journey dates, preferred departure schedule, luggage, and required travel duration."
},
{
question: "Which Jyotirlinga temples can be included in a Pune pilgrimage?",
answer: "The temples included depend on the pilgrimage route and the number of days available for travel. Devotees can discuss their preferred Jyotirlinga destinations with Citysky Cabs and plan the cab itinerary around temple visits, overnight stays, sightseeing requirements, and return travel."
},
{
question: "Is a private cab suitable for a Jyotirlinga Darshan tour?",
answer: "A private cab can be useful for devotees visiting multiple temples because the group can follow an itinerary designed around its own travel requirements. Families can coordinate temple visits, rest breaks, meals, luggage, and overnight stops without having to manage separate transportation."
},
{
question: "Can senior citizens join a Jyotirlinga Darshan trip from Pune?",
answer: "Families travelling with elderly devotees can discuss a private cab arrangement suited to their pilgrimage schedule. The itinerary can take into account preferred departure timings, planned breaks, temple visits, luggage, and the overall comfort requirements of the travelling group."
},
{
question: "Can I book a multi-day cab for Jyotirlinga Darshan from Pune?",
answer: "Devotees planning a pilgrimage over several days can enquire about a cab for the complete journey. Share the planned temples, travel dates, passenger count, overnight destinations, and expected schedule so Citysky Cabs can understand the transportation requirements for the multi-day trip."
},
{
question: "Can families book a Jyotirlinga Darshan package from Pune?",
answer: "Family groups can plan a private pilgrimage vehicle when several relatives want to complete the Jyotirlinga journey together. One dedicated cab can simplify coordination between temple locations while making it easier to manage children, elderly members, personal belongings, and the group's travel schedule."
},
{
question: "Can I customize the Pune Jyotirlinga Darshan itinerary?",
answer: "Travellers can discuss their preferred pilgrimage route and schedule while enquiring about the package. The itinerary may be planned around the temples you want to visit, available travel days, sightseeing preferences, rest requirements, and the final return destination."
},
{
question: "Can I include sightseeing along with Jyotirlinga Darshan?",
answer: "Devotees who want to visit additional attractions during their pilgrimage can mention those requirements while planning the trip. Citysky Cabs can discuss the proposed route, available time, temple schedule, passenger needs, and additional destinations before the travel plan is finalized."
},
{
question: "Is a Jyotirlinga Darshan cab package suitable for a group of devotees?",
answer: "Groups of relatives, friends, or fellow devotees can enquire about private cab transportation for a shared Jyotirlinga pilgrimage. Travelling together makes group coordination simpler and allows everyone to follow the same temple itinerary, departure schedule, and planned overnight stops."
},
{
question: "How can I book a Pune to Jyotirlinga Darshan Package?",
answer: "To enquire about the package, share your Pune pickup location, preferred Jyotirlinga temples, travel dates, number of passengers, luggage details, approximate trip duration, and any additional sightseeing requirements. Citysky Cabs can coordinate the cab arrangement according to your pilgrimage plan."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Mahendra Joshi",
feedback:
"We planned a Jyotirlinga Darshan trip from Pune with my parents and a few relatives. Since the journey involved multiple temple visits, we wanted a private vehicle for the entire group. Citysky Cabs arranged the transportation around our itinerary, and having everyone travel together made it much easier to manage the pilgrimage and daily schedule.",
rating: 5
},
{
id: 2,
name: "Miss. Swati Kulkarni",
feedback:
"Our family had been planning a Jyotirlinga Yatra for some time and finally decided to travel by private cab from Pune. We shared the temples we wanted to cover and our expected travel dates with Citysky Cabs. The dedicated vehicle was convenient for our group, especially because we were travelling with elderly relatives and needed flexibility during the pilgrimage.",
rating: 5
}
];











    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jyotirlinga Darshan Package",
  "image": "https://www.cityskycab.in/assets/images/pune-to-jyotirlinga-darshan-package.webp",
  "description": "Pune to Jyotirlinga Darshan Package from Citysky Cabs is a private pilgrimage travel option for devotees, families and groups planning a multi-temple Jyotirlinga yatra from Pune. The service covers Panch Jyotirlinga Tour from Pune, Panch Jyotirlinga Darshan from Pune, Pune Jyotirlinga Darshan, 3 Jyotirlinga in Maharashtra Tour Package, Maharashtra 5 Jyotirlinga Darshan and dedicated cab services to Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath and Parli Vaijnath. Travellers can arrange a customized itinerary based on the number of temples, travel duration and preferred route, with private transportation throughout the pilgrimage. An Innova Crysta can be selected for families and groups looking for spacious seating and luggage capacity during multi-day temple travel. Citysky Cabs also supports Jyotirlinga Darshan Cab Booking and customized tour packages from Pune, allowing passengers to plan pickup, temple visits, overnight stays and return travel around their pilgrimage schedule.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-jyotirlinga-darshan-package"
  }
};





    return (
        <div>


<Helmet>
  <title>
    Pune to Jyotirlinga Darshan Package | 3 & 5 Jyotirlinga Tour by Cab | +91 8554819191
  </title>

  <meta
    name="description"
    content="Pune to Jyotirlinga Darshan Package by Citysky Cabs for 3 or 5 Jyotirlinga temple tours. Arrange private cab travel to Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath and Parli Vaijnath."
  />

  <meta
    name="keywords"
    content="Panch jyotirlinga tour from pune, Panch jyotirlinga darshan from pune, Pune jyotirlinga darshan, 3 jyotirlinga in maharashtra tour package, 3 jyotirlinga in maharashtra tour package from pune, maharashtra 5 jyotirlinga darshan, pune to bhimashankar cab, pune to trimbakeshwar cab, pune to grishneshwar jyotirlinga cab, pune to aundha nagnath cab service, pune to parli vaijnath cab service, cheapest jyotirlinga darshan cab booking, jyotirlinga darshan package from pune, jyotirlinga darshan tour package, innova crysta for jyotirlinga darshan, Pune to Jyotirlinga Darshan Package, Pune Jyotirlinga private cab, Pune Panch Jyotirlinga taxi, Pune 5 Jyotirlinga cab, Pune 3 Jyotirlinga tour cab, Pune Maharashtra Jyotirlinga taxi, Pune Jyotirlinga pilgrimage cab, Pune Jyotirlinga tour package, Pune Jyotirlinga car rental, Pune Jyotirlinga Innova Crysta, Pune Jyotirlinga family cab, Pune Jyotirlinga group taxi, Pune Jyotirlinga multi day cab, Pune Jyotirlinga temple tour, Pune Jyotirlinga darshan car package, Pune Jyotirlinga cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojyotilingadarshan;